import styled from 'styled-components'

export const StyledLangText = styled.div`
  line-height: 13px;
`

export const StyledLangMenu = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  vertical-align: center;
  div {
    font-size: 13px;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
